import { Box, Text } from 'src/components/ui';
import { ICreative } from 'src/lib/schemas/campaign/newFlowCampaign';
import CreativeCard from './CreativeCard';
import { getFormatedDate } from './utils/formatedDate';
import { customToast } from 'src/services/toast';

interface MessageCreativeProps {
	creative: ICreative;
	withActions?: boolean;
	size?: string;
}

const MessageCreative = ({
	creative,
	withActions = true,
	size = 'md',
}: MessageCreativeProps) => {
	const smsContent = (creative as any).attributes.content;

	const handleCopy = async () => {
		try {
			await navigator.clipboard.writeText(smsContent || '');
			customToast('SMS content copied to clipboard!', 'success');
		} catch (error) {
			customToast('Failed to copy content', 'error');
		}
	};

	return (
		<CreativeCard
			creative={creative}
			withActions={withActions}
			size={size}
			title="SMS"
			onCopy={handleCopy}
		>
			<Box maxW="sm" bg="white" p={4} borderRadius="md" boxShadow="md">
				<Text fontSize="xs" color="gray.500" mb={2} textAlign="center">
					{getFormatedDate()}
				</Text>

				<Box bg="gray.100" p={3} borderRadius="lg" borderBottomLeftRadius="sm">
					<Text data-testid="sms-content" fontSize="sm" color="black">
						{smsContent}{' '}
					</Text>
				</Box>
			</Box>
		</CreativeCard>
	);
};

export default MessageCreative;
